import "@/bl-events/page-loaded"

import "@/modules/base"
import "@/modules/no-legacy"
import "@/modules/lazyload"
import "@/modules/slider"
import "@/modules/abtest-body-class"
import "@/modules/active-between"

import "@/styles/base"
import "@/styles/static-pages"
import "@/styles/static-landing-pages"
import "@/styles/learning-pages"
import "@/styles/landing-page"
import "@/styles/article-landing-page"
import "@/styles/business"
import "@/styles/footer"
import "@/styles/coupon-page"

import "@/features/store-badges/init"
import "@/features/book-card-audio/init"
import "@/features/order-cta/init"
import "@/features/animate/init"
import "@/features/app-reviews/init"
import "@/features/reading-calculator/init"
import "@/features/custom-bg-hero-section/init"
import "@/features/usps/init"
import "@/features/book-slider/init"
import "@/features/expendable-faq/init"
import "@/features/featured-book/init"

import { wdyhauEventHandlers } from "@/modules/wdyhau-survey"
import { registerEventHandlers } from "@/bl-events"
import { eventHandlers as abTestEventHandlers } from "@/modules/abtest-toggle"
import { eventHandlers as categoryExplorerEventHandlers } from "@/features/category-explorer/init"

import { saveSignupDiscountCookie } from "@/modules/signup-discount"
import { setWdyhauTrafficCookie } from "@/modules/wdyhau-survey"

import mountSuccessPage from "@/pages/success-page/mount"
import initErrorPage from "@/pages/error-page/init.js"
import initBusiness from "@/pages/business/init.js"
import initCancellationSurvey from "@/pages/cancellation-survey/init"
import initStay from "@/pages/stay/init"
import initShortcastEpisodePlayer from "@/pages/shortcast-episode-player/init.js"
import initJoin from "@/pages/organisations/init.js"
import initSpacesJoin from "@/pages/spaces/join-page/init.js"
import initSpacesNameInput from "@/pages/spaces/name-input-page/init.js"
import initConnect from "@/pages/organisations/init_connect.js"
import initJoinTeam from "@/pages/join-team-page/init.js"
import initConnectFaq from "@/pages/organisations/faq/init.js"
import initSpacesFaq from "@/pages/spaces/faq/init.js"
import initPosthog from "@/features/posthog/init"
import initDatadogRUM from "@/features/datadog-rum/init"

import initHeader from "@/features/header/header"
import initStickyHeader from "@/features/header/sticky-header"
import initTrialDurationExplanation from "@/features/trial-duration-explanation/init"
import initStickyCta from "@/features/sticky-cta/init.js"
import mountToaster from "@/features/toaster/mount"
import initSmartbanner from "@/features/smartbanner/init"
import initLearningPageHero from "@/features/learning-page-hero/init"

import platform from "@/modules/visitor-platform"
import "@/pages/coupon-landing-page/init"
import store from "@/store/"

registerEventHandlers([
  abTestEventHandlers,
  categoryExplorerEventHandlers,
  wdyhauEventHandlers,
  {
    "setup:ready": (config) => {
      initSmartbanner(config)
      initJoin()
      initSpacesJoin()
      initSpacesNameInput()
      initConnect()
      initJoinTeam()
    },
    "abtest:ready": (testCategories) => {
      initLearningPageHero()
      initTrialDurationExplanation(testCategories)
      initStickyCta()
      store.dispatch("layout/setAbTestVariants", testCategories)

      if (platform.isDesktop()) {
        initStickyHeader()
      }
    }
  }
])

mountToaster()
mountSuccessPage()
initErrorPage()
initHeader()
initShortcastEpisodePlayer()
saveSignupDiscountCookie()
setWdyhauTrafficCookie()
initBusiness()
initCancellationSurvey()
initStay()
initConnectFaq()
initSpacesFaq()
initPosthog()
initDatadogRUM()
